import CampaignConversionsNoData from './campaignConversions';

export default CampaignConversionsNoData;